module.exports = __webpack_public_path__ + "static/media/15B.c2211163.png";